<template>
    <div class="common-confirm dark-page">
        <transition name="mask">
            <div class="confirm-cover" v-show="visible" @click="closeMyself"></div>
        </transition>
        <div class="confirm-wrap">
            <transition name="drop">
                <div class="confirm-body" v-show="visible">
                    <div class="title">
                        <div class="title-left">{{ title }}</div>
                        <div class="title-right" @click="closeMyself">
                            <Icon type="md-close" size="20"/>
                        </div>
                    </div>

                    <div class="content" style="max-width: 550px">
                        <Icon type="ios-alert-outline" class="color" size="22"/>
                        <span>{{ content }}</span>
                    </div>

                    <div class="footer">
                        <div class="cbtn item cancel" @click="closeMyself">{{ close }}</div>
                        <div class="cbtn item sure" @click="besure">{{ sure }}</div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    /** // 先用复杂的用Model调用就行了
     *  vm.$confirm({
     *      title: 'xxxx'.
     *      content:'这是内容'//弹窗的内容
     *  }).then( ()=>{
     *      console.log('promise then')
     *  }).catch( ()=>{
     *      console.log('promise catch')
     *  })
     */
    export default {
        name: 'confirm',
        data() {
            return {
                visible: false,
                title:null,
                content:'',
            }    
        },
        computed:{
            close(){
                return window.vm.$t('common.cancel')
            },
            sure(){
                return window.vm.$t('common.ok')
            }
        },
        methods: {
            show (params){  //初始化参数
                let {title, content } = params
                this.title = title || ""
                this.content = content || "hello"
                this.visible = true
            },
            closeMyself () { // 关闭自己
                this.visible = false;
                this.callBack(false);
                this.destroy()
            },
            besure (){  //确定按钮
                this.visible = false;
                this.callBack(true);
                this.destroy()
            },
            destroy(){
                setTimeout(() => {
                    this.$destroy()
                }, 100);
            },
        },
        destroyed() {
            let parent = this.$el.parentNode
            parent.removeChild(this.$el)
        }
    }
</script>

<style lang="less" scoped src="../style">
    
</style>

